"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getById = getById;
async function getById(refillRepo, id) {
    return await refillRepo.getById(id);
}
